import { Avatar, AvatarProps, Theme, styled } from "@mui/material";

import { CurrencyFlag } from "@dfp/react-flag-images";

type Props = {
  currency: string;
  size?: keyof Theme["avatarSize"];
} & AvatarProps;

export function CurrencyAvatar({ currency, size = 40, ...rest }: Props) {
  return (
    <StyledAvatar size={size} {...rest}>
      <CurrencyFlag currency={currency} width={size} height={size} />
    </StyledAvatar>
  );
}

type StyledAvatarProps = {
  size: keyof Theme["avatarSize"];
};

const StyledAvatar = styled(Avatar)<StyledAvatarProps>(({ theme, size }) => ({
  ...theme.avatarSize[size],
  boxSizing: "border-box",
}));
